import createApi from 'api/createApi';
import qs from 'query-string';

export const tags = {
	geo__settlement: 'mw/geo/settlement',
	geo__zip__search: 'mw/geo/zip',
	geo__street: 'mw/geo/street',
	geo__build: 'mw/geo/build',
	geo__zip: 'mw/geo/zip',
};

export const geoApi = createApi({
	reducerPath: 'mw/geoApi',

	endpoints: (builder) => ({
		geoSettlement: builder.mutation({
			query: (body) => ({
				method: 'GET',
				url: `/mw/geo/settlement?${qs.stringify(body)}`,
			}),
			providesTags: [tags.geo__settlement],
		}),
		geoZipSearch: builder.mutation({
			query: (body) => ({
				method: 'GET',
				url: `/mw/geo/zip?${qs.stringify(body)}`,
			}),
			providesTags: [tags.geo__zip__search],
		}),
		geoStreet: builder.mutation({
			query: (body) => ({
				method: 'GET',
				url: `/mw/geo/street?${qs.stringify(body)}`,
			}),
			providesTags: [tags.geo__street],
		}),
		geoBuild: builder.mutation({
			query: (body) => ({
				method: 'GET',
				url: `/mw/geo/build?${qs.stringify(body)}`,
			}),
			providesTags: [tags.geo__build],
		}),
		geoZip: builder.mutation({
			query: (body) => ({
				method: 'GET',
				url: `/mw/geo/zip?${qs.stringify(body)}`,
			}),
			providesTags: [tags.geo__zip],
		}),
	}),
});

export const {
	geoSettlement,
	geoZipSearch,
	geoStreet,
	geoBuild,
	geoZip,
} = geoApi.endpoints;

export default geoApi;
